export default __webpack_public_path__ + "static/media/meet-minerva-screen-1.8485c344.jpg";